import aboutImg from './../../../../website/assets/images/pexels-setengah-lima-sore-1061582751-31783742.jpg'
import jammu from './../../../../website/assets/images/jammu.jpeg'

import nubraVally from './../../../../website/assets/images/nubra-vally.jpeg'
import modenRider from './../../../../website/assets/images/web-about-us.jpeg'
import gpsImage from './../../../../website/assets/images/gps-image.jpg'
import communityBuilding from './../../../../website/assets/images/growing-community.jpg'




export default function AboutUs() {
  return (<>
    <section class="about" id="about">
      <div class="about-content">
        <h2>motouraX – Fuel Your Freedom</h2>
        <p>
          Welcome to motouraX, the ultimate bike riding app designed for riders who want more than just navigation. Whether you're a daily commuter, weekend explorer, or long-distance touring enthusiast, motouraX helps you track, analyze, and share every ride with precision.
        </p>
        <b>Start your journey. Track your ride. Fuel your freedom.</b>
      </div>
      <div class="about-image">
        <img src={aboutImg} alt="About MOTO" />
      </div>
    </section>
    <section class="about" id="about">
      <div class="about-image">
        <img src={nubraVally} alt="About MOTO" />
      </div>
      <div class="about-content">
        <h2>Your All-in-One Bike Riding Companion</h2>
        <p>
          motouraX is built to deliver a seamless riding experience with powerful features like real-time GPS tracking, route recording, and ride analytics. Our platform captures every movement of your journey, allowing you to view detailed ride history, distance, speed, and performance insights.

          With advanced route tracking technology, riders can explore new paths, revisit favorite routes, and never lose their way. Every ride is stored securely and visualized on interactive maps, making it easy to relive your adventures anytime.
        </p>
      </div>
      </section>
      <section class="about" id="about">
        <div class="about-content">
          <h2>Built for the Modern Rider</h2>
          <p>
            In today’s fast-growing biking culture, riders need more than just a basic tracking app. motouraX combines technology and community to create a platform where riders can connect, share experiences, and discover new routes together.

            From solo rides to group adventures, motouraX supports:
            <ul>
              <li>Live ride tracking</li>

              <li>Route sharing and navigation</li>

              <li>Performance analytics</li>

              <li>Community-driven exploration</li> </ul>   </p>
          {/* <b>Start your journey. Track your ride. Fuel your freedom.</b> */}
        </div>
        <div class="about-image">
          <img src={modenRider} alt="About MOTO" />
        </div>
      </section>
      <section class="about" id="about">
      <div class="about-image">
        <img src={gpsImage} alt="About MOTO" />
      </div>
      <div class="about-content">
        <h2>Powerful GPS Tracking & Ride Analytics</h2>
        <p>
          Our intelligent GPS system ensures accurate tracking of your rides, even in challenging environments. motouraX converts your ride data into meaningful insights, helping you understand your performance and improve over time.

Track key metrics like:

Distance covered

Average and maximum speed

Ride duration

Route history with map visualization
        </p>
      </div>
      </section>
      <section class="about" id="about">
        <div class="about-content">
          <h2>Join a Growing Biking Community</h2>
          <p>
            motouraX is more than just a bike tracking app — it’s a platform for riders to connect and grow together. Discover trending routes, share your journeys, and become part of a community that shares your passion for riding.

Whether you're riding through city streets or exploring off-road trails, motouraX helps you stay connected to the road and fellow riders.
             </p>
          {/* <b>Start your journey. Track your ride. Fuel your freedom.</b> */}
        </div>
        <div class="about-image">
          <img src={communityBuilding} alt="About MOTO" />
        </div>
      </section>
  </>
  );
}
